export const getDefaultOptions = () => ({
    cwd: '.',
});
